import styled from "styled-components";

export const StyledSideNav = styled.aside<{
  visible?: boolean;
}>`
  background-color: #fff;
  border-radius: 2rem;
  border: 1px solid #f0f0f0;
  padding: 1.2rem;
  width: 100%;
  height: 95svh;
  position: relative;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  transition-property: width, transform !important;
  transition-duration: 0.3s !important;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1) !important;
  @media (max-width: 960px) {
    padding-top: 6.5rem;
    z-index: 90;
    position: fixed;
    width: 24.6rem;
    transform: translate3d(
      ${({visible}) => (visible ? 0 : "calc(24.6rem - 24.6rem*2)")},
      0,
      0
    );
    transition: transform 0.3s
      ${({visible}) =>
        visible ? "cubic-bezier(0.4, 0, 1, 1)" : "cubic-bezier(0, 0, 0.2, 1)"} !important;
    height: 100svh;
    margin-top: 0;
  }
`;

export const StyledFixedHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`;

export const StyledLogoContainer = styled.div<{
  visible?: boolean;
}>`
  margin-bottom: 1rem;
  width: 12.1rem;
  height: 4.085rem;

  @media only screen and (max-width: 960px) {
    display: none;
  }
`;

export const StyledScrollableMenu = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  /* width */
  &::-webkit-scrollbar {
    width: 1rem;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 1rem;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #ebebeb;
    border-radius: 1rem;
  }
`;

export const StyledFixedFooter = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`;
